import React from "react";
import { useState } from "react";
import styles from "../../../styles/brsr/general.module.css";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import LensIcon from "@mui/icons-material/Lens";
import PolicyManagement from "../../../Components/BRSR/SectionB/PolicyManagement";
import Governance from "../../../Components/BRSR/SectionB/Governance";

const SectionB = () => {
  const [currentComponent, setCurrentComponent] = useState("Policy");

  const steps = ["Policy", "Governance"];

  const DottedLineBetweenSteps = () => {
    return (
      <div
        style={{
          width: "100%",
          height: "3px",
          background:
            "repeating-linear-gradient(to right, #B3B3B3, #B3B3B3 10px, transparent 5px, transparent 15px)",
        }}
      />
    );
  };

  const goToNextComponent = () => {
    const currentIndex = steps.findIndex((step) => step === currentComponent);
    if (currentIndex < steps.length - 1) {
      setCurrentComponent(steps[currentIndex + 1]);
    }
  };

  return (
    <>
      <div className={styles.section_navbar}>
        <div className={styles.sectionb_navbar_wrapper}>
          <div onClick={() => setCurrentComponent("Policy")}>
            {currentComponent === "Policy" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Governance")}>
            {currentComponent === "Governance" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
        </div>

        <div className={styles.sectionc_navbar_steps}>
          <p style={{marginLeft:"-2rem"}}>Policy and management processes</p>
          <p style={{marginRight:"-3rem"}}>Governance, leadership and oversight</p>
        </div>
      </div>
      <p className={styles.section_heading}>
        SECTION B: MANAGEMENT AND PROCESS DISCLOSURES
      </p>
      <div>
        {currentComponent === "Policy" ? (
          <PolicyManagement onSave={goToNextComponent} />
        ) : currentComponent === "Governance" ? (
          <Governance onSave={goToNextComponent} />
        ) : null}
      </div>
    </>
  );
};

export default SectionB;
